import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectsRoutingModule } from './projects-routing.module';
import { UiModule } from '@piqet-angular/ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { ProjectDetailsModule } from './project-details/project-details-module';
import { ProductDetailsModule } from './product-details/product-details.module';
import { ProductProjectDetailsComponent } from './product-details/product-project-details/product-project-details.component';
import { LetModule } from '@ngrx/component';
import { PackagingProjectsComponent } from './packaging-projects/packaging-projects.component';
import { ProductProjectsComponent } from './product-projects/product-projects.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { JoyrideModule } from 'ngx-joyride';

@NgModule({
  declarations: [
    ProjectDetailsComponent,
    ProductProjectDetailsComponent,
    PackagingProjectsComponent,
    ProductProjectsComponent,
  ],
  imports: [
    CommonModule,
    ProjectsRoutingModule,
    CommonModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    ProjectDetailsModule,
    ProductDetailsModule,
    LetModule,
    PDFExportModule,
    JoyrideModule.forChild(),
  ],
  exports: [PackagingProjectsComponent, ProductProjectsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectModule {}
